import type { RouterConfig, SelfHelpCloseOnesRouteName } from '../../containers/Routes/types';

// Pages.
import PageAccountAvatar from '../Account/Avatar';
import PageAccountChangeEmail from '../Account/ChangeEmail';
import PageAccountChangePassword from '../Account/ChangePassword';
import PageAccountMessages from '../Account/Messages';
import PageAccountSetting from '../Account/Settings';

const routesConfigAccountCloseOnes: RouterConfig<SelfHelpCloseOnesRouteName> = {
  accountAvatar: {
    basePath: '/account/mijn-avatar',
    nl: '/nl/account/mijn-avatar',
    en: '/en/account/my-avatar',
    type: 'private',
    component: PageAccountAvatar,
  },
  accountBase: {
    basePath: '/account',
    nl: '/nl/account',
    en: '/en/account',
    type: 'private',
    component: PageAccountSetting,
  },
  accountEmail: {
    basePath: '/account/email-wijzigen',
    nl: '/nl/account/email-wijzigen',
    en: '/en/account/change-email',
    type: 'private',
    component: PageAccountChangeEmail,
  },
  accountMessages: {
    basePath: '/account/meldingen',
    nl: '/nl/account/meldingen',
    en: '/en/account/notifications',
    type: 'private',
    component: PageAccountMessages,
  },
  accountPassword: {
    basePath: '/account/wachtwoord-wijzigen',
    nl: '/nl/account/wachtwoord-wijzigen',
    en: '/en/account/change-password',
    type: 'private',
    component: PageAccountChangePassword,
  },
};

export default routesConfigAccountCloseOnes;
